import shortcutController from '../classes/shortcutController';
import { TMap } from '../types';
import debugDispatcher from '../utils/debugDispatcher';
import { getSpecificParent } from '../utils/dom';
import { getValueByPath } from '../utils/util';

export default function nomatter() {}
function stopPropagation(ev: MouseEvent) {
  ev.preventDefault();
  ev.stopImmediatePropagation();
  ev.stopPropagation();
}

export function shoutVariant(ev: MouseEvent) {
  ev.preventDefault();
  ev.stopImmediatePropagation();
  ev.stopPropagation();
  window.getElementVariant(ev.target as HTMLElement);
  return false;
}

let isVariantGetterEnabled = false;
function toggleVariantGetter() {
  function unsuscribe() {
    isVariantGetterEnabled = false;
    document.removeEventListener('mousedown', shoutVariant, true);
    document.removeEventListener('click', stopPropagation, true);
    document.removeEventListener('keydown', handleEscape, true);
    console.info('Variant getter enabled: ', isVariantGetterEnabled);
  }

  function handleEscape(ev: KeyboardEvent) {
    if (ev.code === 'Escape') {
      unsuscribe();
    }
  }

  if (isVariantGetterEnabled) {
    unsuscribe();
  } else {
    isVariantGetterEnabled = true;
    document.addEventListener('mousedown', shoutVariant, true);
    document.addEventListener('click', stopPropagation, true);
    document.addEventListener('keydown', handleEscape, true);
  }
  console.info('Variant getter enabled: ', isVariantGetterEnabled);
}

export function setVariantCommands() {
  shortcutController.on(
    [{ key: 'D', shiftKey: true }, ...'variant'.split('')],
    toggleVariantGetter,
  );
  debugDispatcher.on(
    'variant',
    toggleVariantGetter,
    'Permite activar o desactivar la herramienta de inspección de variantes',
  );
  window.getElementVariant = (element) => {
    let foundElement: HTMLElement | null = element;
    do {
      foundElement = getSpecificParent(foundElement.parentElement, (current) =>
        current.matches('[data-variant]'),
      );
      if (foundElement) {
        console.info({
          element,
          parentElement: foundElement,
          parentVariant: foundElement.dataset.variant,
        });
        console.info(
          'Variant definition: ',
          getValueByPath(
            window.appliedTheme as unknown as TMap,
            foundElement.dataset.variant as string,
          ),
        );
        console.info('-----------');
      } else console.info('-----------');
    } while (foundElement);
  };
  window.getVariant = (variant) => ({ variant, 'data-variant': variant });
}
